import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dropdownFn = /* @__PURE__ */ createRecipe('dropdown', {}, [])

const dropdownVariantMap = {}

const dropdownVariantKeys = Object.keys(dropdownVariantMap)

export const dropdown = /* @__PURE__ */ Object.assign(memo(dropdownFn.recipeFn), {
  __recipe__: true,
  __name__: 'dropdown',
  __getCompoundVariantCss__: dropdownFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dropdownVariantKeys,
  variantMap: dropdownVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dropdownVariantKeys)
  },
  getVariantProps: dropdownFn.getVariantProps,
})